import ChangeRateForm from './ChangeRateForm';

export default ChangeRateForm;
